import React from 'react'

export default function BeeswaxTag() {
    var cachebuster = new Date().getTime() / 1000

    return (
        <img
            style={{ height: 0, width: 0 }}
            alt="beeswax-tag"
            src={`https://cnv.event.prod.bidr.io/log/cnv?tag_id=1&buzz_key=homespotter&value=&segment_key=homespotter-618467&ord=${cachebuster}`}
        />
    )
}
